// extracted by mini-css-extract-plugin
export default {"loadingIcon":"src-components-IconLoading-index-module_loadingIcon--bXZ5h"};